(function() {

    'use strict';


    /**
     * HTML5 implementation for the VideoAbstract solution
     */


    var Feat = SAPO.Project.Video.Features;

    // early exit
    if (!Feat.supportsVideoElement) { return; }


    var isAndroid = (/android/).test( navigator.userAgent.toLowerCase() );

    var DELTAT = Math.round( 0.25 * 1000 );

    var SKIP_LIVE_TIMEOUT_DETECTION = 1;



    var nearestEnd = function(ct, vBuffered) {
        var a, b;
        for (var i = vBuffered.length - 1; i >= 0; --i) {
            a = vBuffered.start(i);
            b = vBuffered.end(i);
            if (ct >= a && ct <= b) {
                return i;
            }
        }
        return -1;
    };



    // video abstraction (uri is optional)
    var VideoHtml5Impl = function VideoHtml5Impl(o, va) {
        this._options = o;

        this._va = va;

        this._recreateElement();

        if (this._options.onReady) {
            //console.log('VIDEOHTML5 ONREADY');
            var _this = this;
			// Magical ST0. Needed to prevent launching the event before the videoHighEnd is subscribing it
            setTimeout(function(){
                _this._va.fire('impl_ready', 'html5');
            }, 0);
            this._options.onReady(this);

            this._isReady = true;
        }
    };

    VideoHtml5Impl.prototype = {
        // EVENTS

        _recreateElement: function() {
            this._el = document.createElement('video');

            var o = this._options;

            this._el.setAttribute('width',    '2');
            this._el.setAttribute('height',   '1');
            this._el.setAttribute('tabindex', '-1');
            this._el.setAttribute('poster',   'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==');

            this._el.className = 'video';

            var preloadValue = 'auto';
            if (o.prefetch === true) { preloadValue = 'auto'; }
            else {                     preloadValue = 'none'; }
            this._el.setAttribute('preload', preloadValue);
            //console.log('video html5 preload: ', preloadValue);

            this._el.setAttribute('x-webkit-airplay', 'allow');

            if (this._options.container) {
                if (this._options.insteadOf) {
                    this._options.container.parentNode.replaceChild(this._el, this._options.container);
                }
                else {
                    this._options.container.appendChild(this._el);
                }
            }

            if (o.src) {
                //console.log('HTML5 IMPL CTOR SRC', o.src);
                this._el.setAttribute('src', o.src);
            }

            if (o.poster) {
                this.setPoster(o.poster);
            }

            this._canAutoplay = /*SAPO.Project.Video.Features.isIPhoneOrIPod ||*/ !SAPO.Project.Video.Features.isMobile; // TODO hardcoded

            var that = this;

            if (SAPO.Project.Video.Features.isMobile /*|| SAPO.Project.Video.Features.isIPhoneOrIPod*/) {
                //window.top.log('CANNOT YET AUTOPLAY');
                var setCanAutoplay = function setCanAutoplay() {
                    that._canAutoplay = true;
                    //window.top.log('CAN NOW AUTOPLAY');
                    that._el.removeEventListener('play', setCanAutoplay);
                };

                this._el.addEventListener('play', setCanAutoplay);
            }



            // TODO WARNING - ended fix for MF browsers who do not report it (ex: SAMSUNG S4 STOCK BROWSER)
            if (SAPO.Project.Video.Features.isAndroid) {
                var fixTimer;

                var fireEnded = function() {
                    that._va.fire('ended');
                    fixTimer = undefined;
                    //window.top.log('FAKE FIRE ENDED');
                };

                var skipFireEnded = function() {
                    clearTimeout(fixTimer);
                    fixTimer = undefined;
                    //window.top.log('REAL FIRE ENDED');
                };

                var endedFixCb = function() {
                    var d = that._el.duration;
                    if (isFinite(d) && !that._isLive) {
                        var ct = that._el.currentTime;
                        //var x = d - ct < 0.2;
                        //alert(d + ' ' + ct);
                        if (isFinite(ct) && d - ct < 0.2) {
                            if (fixTimer) { return; }

                            that._el.addEventListener('ended', skipFireEnded);

                            fixTimer = setTimeout(fireEnded, 220);
                        }
                    }
                };

                this._el.addEventListener('timeupdate', endedFixCb);
            }

            if (SAPO.Project.Video.Features.isIPhoneOrIPod) {

                this._el.addEventListener('webkitbeginfullscreen', function() {
                    //window.top.log('IPHONE webkitbeginfullscreen');
                    that._el.play();
                });

                this._el.addEventListener('webkitendfullscreen', function() {
                    //window.top.log('IPHONE webkitendfullscreen');
                    that._va.fire('ended', true);
                });
            }

        },



        addEventListener: function(eventName, cb) {
            //Event.observe(this._el, eventName, cb);
            this._el.addEventListener(eventName, cb, false);
        },

        removeEventListener: function(eventName, cb) {
            //Event.stopObserving(this._el, eventName, cb);
            this._el.removeEventListener(eventName, cb, false);
        },



        // LOAD AND PLAY STATE

        canAutoplay: function() {
            return this._canAutoplay;
        },

        load: function(src, type, startPlaying) {
            var that = this;

            this._isLive = (src.indexOf('.m3u8') !== -1);

            delete this._duration;
            delete this._realDims;

            this._loadedmetadataEventWasFired = false; // fix for some browsers which do not trigger this event

            //console.log('HTML5 IMPL LOAD SRC:', src);

            var lastType = this._lastType || type;

            /*if (wasPlaying) {
                this.pause();
            }*/

            //console.log('HMTL5IMPL src:', src, ' type:', type, ' startPlaying:', startPlaying);

            if (SAPO.Project.Video.Features.isIPhoneOrIPod) {
                if (lastType !== type) {
                    //console.log('TYPE CHANGED');
                    this._el.parentNode.removeChild(this._el);
                    this._el = undefined;

                    this._recreateElement();

                    //window.top.log('FAKE PAUSE');
                    that._va.fire('pause'); // to fix the state of the interface

                    this._va._subscribeImplEvents();
                }
            }

            this._el.setAttribute('src', src);

            this._lastType = type;

            if (startPlaying) {
                this._el.setAttribute('autoplay', '');
            }

            this._el.load();

            if (startPlaying) {
                this.play();  //console.log('ATTEMPTING PLAYBACK...');
            }
        },

        unload: function() {
            //console.log( this._el.getAttribute('src') );
            this._el.setAttribute('src', '');
            this._el.removeAttribute('src');
        },

        isPlaying: function() {
            return (!this._el.paused && !this._el.ended);
        },

        play: function() {
            this._el.play();

            if (this._isLive && !this._timerI) {
                this._timerI = setInterval(this._onTimerLive.bindObj(this), DELTAT);
            }
        },

        pause: function() {
            this._el.pause();

            if (this._isLive && this._timerI) {
                this._resetTimer();
            }
        },



        // TIME-RELATED

        getCurrentTime: function() {
            //return this._el.currentTime;
            try {
                return this._el.currentTime;
            } catch (ex) {
                return 0;
            }
        },

        setCurrentTime: function(t) {
            try {
                this._el.currentTime = t;
            } catch (ex) {}
        },

        getDuration: function() {
            if (this._isLive) { return undefined; }
            if (this._duration) { // TO FIX STOCK BROWSER BORKED DURATIONS
                return this._duration;
            }
            if (this._el) {
                return this._el.duration;
            }
        },

        // object with start and length (in percentage)
        getCache: function(asRatio) {
            var ct = this._el.currentTime;
            var d = this._el.duration;
            var i = nearestEnd(ct, this._el.buffered);

            //console.log('ct:%s, rangeI:%s, numRanges:%s', ct, i, this._el.buffered.length);

            if (i === -1) {
                return;
            }

            var a = this._el.buffered.start(i);
            var b = this._el.buffered.end(i);
            var l = b - a;

            //console.log('start:%s, end:%s', a.toFixed(1), b.toFixed(1));

            if (asRatio) {
                a /= d;
                b /= d;
                l /= d;
            }

            return {
                start:  a,
                end:    b,
                length: l
            };
        },

        isLive: function() {
            return !!this._isLive;
        },

        isReady: function() {
            return !!this._isReady;
        },



        // VOLUME-RELATED

        getVolume: function() {
            return this._el.volume;
        },

        setVolume: function(v) {
            this._el.volume = v;
        },



        // SIZE

        getVideoSize: function() {
            if (this._realDims) {
                return this._realDims;
            }
            var d = [this._el.videoWidth, this._el.videoHeight];
            if (d[0] > 100 && d[1] > 100) {
                this._realDims = d;
            }
            return d;
        },



        // DOM
        getElement: function() {
            return this._el;
        },

        kill: function() {
            if (this._timerI) {
                this._resetTimer();
            }

            this._el.parentNode.removeChild(this._el);
            this._el = undefined;
        },

        _resetTimer: function() {
            clearInterval(this._timerI);
            delete this._timerI;
            delete this._liveStartT;
        },

        _onTimerLive: function() {
            var t = new Date().valueOf() / 1000;

            if (!this._liveStartT) {
                //console.log('LIVE TIMER STARTED COUNTING...')
                this._liveStartT = t;
            }
            else {
                var ct = this.getCurrentTime();
                var dt = t - this._liveStartT;
                var isInvalid = (ct < 0.1 || isNaN(ct));

                if (isInvalid && dt > 5) {
                    //console.log(dt.toFixed(2), 'NO STREAM?', ct);
                }
                else if (!isInvalid) {
                    this._va.fire('timeupdate');
                    this._liveStartT = t;
                }
            }
        }
    };

    if (SKIP_LIVE_TIMEOUT_DETECTION) {
        VideoHtml5Impl.prototype._onTimerLive = VideoHtml5Impl.prototype._onTimer;
    }



    /*
     * single argument memo where argument cached as string (no objects please)
     *
     * @function memo
     * @param  {Function} fn function to memoize
     * @return {Function} memoized version of the function
     */
    var memo = function(fn) {
        return function(a) {
            if (!fn._memo) {
                fn._memo = {};
            }
            var v;
            if (a in fn._memo) {
                v = fn._memo[a];
            }
            else {
                v = fn(a);
                fn._memo[a] = v;
            }
            return v;
        };
    };



    // this method is static and regular
    VideoHtml5Impl.canMimeTypeBePlayed = VideoHtml5Impl.prototype.canMimeTypeBePlayed = memo(function(mimeType) {

        mimeType = mimeType.toLowerCase();

        var el = document.createElement('video');

        switch (mimeType) {
            case 'video/x-flv':
            case 'rtmp/flv':
            case 'rtmp/mp4':
                return false;

            case 'video/mp4':
                return !!( el.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '') );

            case 'application/vnd.apple.mpegurl':
            case 'application/x-mpegurl':
                return !!( el.canPlayType('application/x-mpegurl'        ).replace(/^no$/, '') ||
                           el.canPlayType('application/vnd.apple.mpegurl').replace(/^no$/, '') ||
                           isAndroid );

            default:
                return !!( el.canPlayType(mimeType) );
        }
    });



    SAPO.namespace('Project.Video.Controllers');
    SAPO.Project.Video.Controllers.VideoHtml5Impl = VideoHtml5Impl;

    SAPO.Project.Video.Controllers.videoImpls['html5'] = VideoHtml5Impl;

})();
